import { request } from '../utils';
import { GET, ASSET_MANAGER_DAAPI_API } from '../constants';

export const getAllDsp = async () =>
  request(GET, `${ASSET_MANAGER_DAAPI_API}/v5/lookups/dsps`, {}, {}, 'Failed to get dsp data');
